module.exports = __webpack_public_path__ + "static/media/AB_K2_1.d2c91bc4.jpg";